import "./style.scss";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperClass } from "swiper/types";
import { Navigation, Pagination } from "swiper/modules";
import SubMenuSlideOne from "@/src/assets/Header/SubMenuSlideOne.png";

const HeaderDeskSubMenuSlider = () => {
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="sub-menu-content-news-slider">
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        navigation={{
          prevEl: prevRef.current!,
          nextEl: nextRef.current!,
        }}
        pagination={{
          el: ".sub-menu-slider-pagination",
          clickable: true,
        }}
        onBeforeInit={(swiper: SwiperClass) => {
          if (typeof swiper.params.navigation !== "boolean" && swiper.params.navigation) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }
        }}
      >
        <SwiperSlide className="sub-menu-content-news-slider-slide">
          <div className="sub-menu-content-news-slider-background">
            <img src={SubMenuSlideOne} alt="Sub Menu Slider Img" />
          </div>
          <div className="sub-menu-content-news-slider-content">
            <div className="sub-menu-content-news-slider-content-title">Refresher courses</div>
            <div className="sub-menu-content-news-slider-content-description">
              leading regional institution offering a wide range of academic programs and
              disciplines.
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="sub-menu-content-news-slider-background">
            <img src={SubMenuSlideOne} alt="Sub Menu Img" />
          </div>
          <div className="sub-menu-content-news-slider-content">
            <div className="sub-menu-content-news-slider-content-title">Refresher courses2</div>
            <div className="sub-menu-content-news-slider-content-description">
              leading regional institution offering a wide range of academic programs and
              disciplines.
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="sub-menu-content-news-slider-background">
            <img src={SubMenuSlideOne} alt="Sub Menu Img" />
          </div>
          <div className="sub-menu-content-news-slider-content">
            <div className="sub-menu-content-news-slider-content-title">Refresher courses3</div>
            <div className="sub-menu-content-news-slider-content-description">
              leading regional institution offering a wide range of academic programs and
              disciplines.
            </div>
          </div>
        </SwiperSlide>
        <div className="sub-menu-slider-pagination" />
      </Swiper>
    </div>
  );
};

export default HeaderDeskSubMenuSlider;
